/**
 * OrbDocCoreConceptsPagesAROrbDocCoreConceptsPagesARPage
 *
 * Page component for OrbDocCoreConceptsPagesAROrbDocCoreConceptsPagesARPage
 * Path: /ar/docs/core-concepts/pages
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocCoreConceptsPagesARDocScreenView as __OrbDocCoreConceptsPagesARDocScreenView } from '@/components/traits/OrbDocCoreConceptsPagesARDocScreenView';
import { OrbDocCoreConceptsPagesARDocAnalyticsView as __OrbDocCoreConceptsPagesARDocAnalyticsView } from '@/components/traits/OrbDocCoreConceptsPagesARDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocCoreConceptsPagesAROrbDocCoreConceptsPagesARPageProps {
  // Add any page-level props here
}

export function OrbDocCoreConceptsPagesAROrbDocCoreConceptsPagesARPage(_props: OrbDocCoreConceptsPagesAROrbDocCoreConceptsPagesARPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"الصفحات","description":"المسارات، وكيف تتشارك السمات على المسار نفسه الشاشة.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/core-concepts/pages"},{"locale":"ar","path":"/ar/docs/core-concepts/pages"},{"locale":"sl","path":"/sl/docs/core-concepts/pages"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocCoreConceptsPagesARDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocCoreConceptsPagesARDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocCoreConceptsPagesAROrbDocCoreConceptsPagesARPage;
